import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActiveDirectoryAddEditModel } from "../models/ADModels/ActiveDirectoryAddEditModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";

@Injectable({
  providedIn: 'root'
})
export class ActiveDirectoryService {
  ApiUrl = "/api/admin/ADConnection/"

  constructor(private http: RequestHandlerService) { }

  AddActiveDirectory(AddModel: ActiveDirectoryAddEditModel) {
    return this.http.post( this.ApiUrl + 'AddActiveDirectory', AddModel);
  }

  GetEditActiveDirectory( id: string) {
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.get( this.ApiUrl + 'EditActiveDirectory',  params );

  }

  EditActiveDirectory(EditModel: ActiveDirectoryAddEditModel) {
    return this.http.post( this.ApiUrl + 'EditActiveDirectory', EditModel);
  }

  DeleteActiveDirectory( id: string) {
  
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.post( this.ApiUrl + 'DeleteActiveDirectory', null,  params );
  }
  Loaddropdowns() {
   
    return this.http.get( this.ApiUrl + 'Loaddropdowns');
  }
  RunADSynchronization( id: string) {
    
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.post( this.ApiUrl + 'RunADsync', null, params);
  }

  GetLastRunLogs( id: string) {
 
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.get( this.ApiUrl + 'LastRunLogs', params);
  }

  CheckValidationandGetData(model: ActiveDirectoryAddEditModel) {   
 
    return this.http.post( this.ApiUrl + 'GetADData', model,null);
  }
}
